<template>
    <div class="route-country-info" :class="{ 'route-country-info--short' : shortInfo }">
        <div class="route-country-info__section" v-for="country in formattedCountryInfos" :key="country.countryCode">
            <div class="sidebar__section sidebar__section--border-bottom route-country-info__section__inner">
                <div class="route-country-info__section__title h4">
                    <img class="list-info-item__summary__image route-country-info__section__image" :src="country.image"/> {{ country.name }}
                </div>
            </div>

            <!-- Short info section -->
            <div class="route-country-info__section__main" v-if="country.data && shortInfo">
                <div class="route-country-info__section__main__inner">
                    <div class="route-country-info__section__main__section" v-for="(entry, index) in country.data" :key="index">
                        <div class="route-country-info__section__main__item" v-for="(section, sectionIndex) in entry.content" :key="sectionIndex">
                            <div v-if="section.label">{{ section.label}}</div>
                            <div v-if="section.subContent">
                                <div v-for="(subContent, index) in section.subContent" :key="index">
                                    <div>{{ subContent.label }}</div>
                                    <div class="copy-light" v-html="subContent.text"></div>
                                </div>
                            </div>
                            <div class="copy-light" v-html="section.text"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Länder info section -->
            <div class="route-country-info__section__main" v-if="country.data && !shortInfo">
                <el-collapse :value="country.openedInfos" ref="collapse">
                    <ListInfoItem type="collapse" :sidebarSection="false" class="list-info-item--simple" :hasIcon="false" v-for="(entry, index) in country.data" :key="index" :collapseName="`info-${index}`">
                        <template slot="summary">
                            <div class="list-info-item__summary__texts">
                                <div class="list-info-item__summary__title h5">{{ entry.title }}</div>
                            </div>
                        </template>
                        <template slot="content">
                            <div class="list-info-item__section list-info-item__section--border-bottom" v-for="(section, sectionIndex) in entry.content" :key="sectionIndex">
                                <div v-if="section.label" class="list-info-item__row list-info-item__row--black list-info-item__row--no-space h4" v-html="section.label"></div>
                                <div v-if="section.subContent">
                                    <div v-for="(subContent, index) in section.subContent" :key="index">
                                        <div class="list-info-item__row list-info-item__row--black list-info-item__row--no-space h4" :class="{ 'list-info-item__row--space-top' : index > 0}">
                                            {{ subContent.label }}
                                        </div>
                                        <div class="list-info-item__row copy-light" v-html="subContent.text"></div>
                                    </div>
                                </div>
                                <div v-if="section.text" class="list-info-item__row copy-light" :class="{ 'list-info-item__row--space-top' : section.subContent }" v-html="section.text"></div>
                            </div>
                        </template>
                    </ListInfoItem>
                </el-collapse>
            </div>
        </div>
        <div class="sidebar__section" v-if="countryInfo.length === 0">
            <NoResultsMessage type="COUNTRYINFO" />
        </div>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus'

export default {
    components: {
        ListInfoItem: () => import(/* webpackChunkName: "ListInfoItem" */ '@/components/ListInfoItem.vue'),
        NoResultsMessage: () => import(/* webpackChunkName: "NoResultsMessage" */ '@/components/NoResultsMessage.vue'),
    },
    props: {
        countryInfo: {
            type: Array,
            default: () => []
        },
        shortInfo: {
            type: Boolean,
            default: false
        },
        route: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            formattedCountryInfos: JSON.parse(JSON.stringify(this.countryInfo))
        }
    },
    watch: {
        countryInfo(newVal) {
            this.formattedCountryInfos =  JSON.parse(JSON.stringify(newVal))
            this.prepareCountryInfos()
        }
    },
    created() {
        this.addListeners()
        this.prepareCountryInfos()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        showCountryInfoTollsHandler(e) {
            const selectedCountry = e.country
            this.formattedCountryInfos.forEach((country, countryIndex) => {
                country.openedInfos = []
                if(country.data && country.data.length > 0 && country.countryCode === selectedCountry) {
                    country.data.forEach((data, dataIndex)=> {
                        if(data.type && data.type === 'tolls-vignette') {
                            country.openedInfos = [`info-${dataIndex}`]
                            if(this.$refs.collapse[countryIndex] !== undefined) {
                                this.$refs.collapse[countryIndex].setActiveNames(country.openedInfos)
                            }
                        }
                    })
                }
            })
        },
        addListeners() {
            eventBus.$on('showCountryInfoTolls', this.showCountryInfoTollsHandler)
        },
        removeListeners() {
            eventBus.$off('showCountryInfoTolls', this.showCountryInfoTollsHandler)
        },
        prepareCountryInfos() {
            this.formattedCountryInfos.forEach((country, countryIndex) => {
                if(country.data && country.data.length > 0) {
                    country.openedInfos = []
                    if(countryIndex === 0) country.openedInfos.push('info-0')
                }
            })
        }
    }
}
</script>

<style lang="scss">
.route-country-info {
    $block: &;
    margin-top: -15px;

    &--short {
        #{$block} {
            &__section {
                border-bottom: none;

                &__inner {
                    padding-right: 0;
                    border-bottom: none;
                    margin-bottom: 0;
                }

                &__title {
                    padding: 24px 16px 19px 0;  
                }

                &__image {
                    width: 20px;
                    margin-right: 18px
                }

                &__main {
                    display: flex;
                    flex-direction: column;
                    padding: 0 0 0 54px;

                    &__inner {
                        border-bottom: 1px solid $color-black-005;
                        margin-bottom: 24px;
                        padding-bottom: 11px;
                    }

                    &__section {
                        &:not(:last-child) {
                            margin-bottom: 22px;
                        }
                    }

                    &__item {
                        padding: 0 16px 0 0;

                        &:not(:last-child) {
                            margin-bottom: 22px;
                        }

                        strong, b {
                             font-weight: $font-weight-regular;
                            color: $color-black;
                        }
                    }
                }
            }
        }
    }

    &__section {
        &:not(:last-child) {
            border-bottom: 1px solid $color-black-005;
        }
        &__title {
            padding: 16px 0 17px;
            display: flex;
            align-items: center;
        }
        &__main {
            padding-top: 4px;
            padding-bottom: 24px;
        }

        &__inner {
            margin-bottom: 16px;
        }
    }
}
</style>